import React from "react";
import { Button, InputNumber, List, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { BrickSeries } from "../../store/slices/bricksSlice";

interface Props {
  brick: BrickSeries;
  onClick?(): void;
  deletable?: boolean;
  onDelete?(): void;
  rate?: number;
  rateInput?: boolean;
  onRateInput?(val: number): void;
  selected?: boolean;
}

export const StoneRow: React.FC<Props> = ({
  brick,
  onClick,
  rate,
  rateInput,
  onRateInput,
  deletable,
  onDelete,
  selected,
}) => {
  return (
    <List.Item
      className={`stone-row ${selected ? "selected" : ""}`}
      onClick={() => onClick?.()}
      style={{ paddingLeft: 24, paddingRight: 24, display: "flex" }}
    >
      <img width={100} src={brick.displayThumbnail ?? undefined} loading="lazy" />
      <span>{brick.name}</span>
      <Space>
        {rateInput && (
          <InputNumber
            value={rate}
            defaultValue={100}
            min={0}
            max={100}
            step={5}
            formatter={(value) => `${value ?? 0}%`}
            parser={(value) => parseInt((value ?? "0").replace("%", ""))}
            onChange={(val) => onRateInput?.(val ?? 0)}
          />
        )}
        {deletable && (
          <Button danger onClick={onDelete} icon={<DeleteOutlined />} />
        )}
      </Space>
    </List.Item>
  );
};
